// Department service for KATA Dashboard

import { apiClient, handleApiError } from './api';
import { Department, ApiResponse } from '../types/api';

export interface DepartmentFilters {
  plant?: number;
  search?: string;
  page?: number;
  page_size?: number;
}

export class DepartmentService {
  /**
   * Get departments with filtering
   */
  static async getDepartments(filters: DepartmentFilters = {}): Promise<ApiResponse<Department>> {
    try {
      const params = new URLSearchParams();
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });

      const response = await apiClient.get<ApiResponse<Department>>(`/departments/?${params}`);
      return response.data;
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get department by ID
   */
  static async getDepartment(id: number): Promise<Department> {
    try {
      const response = await apiClient.get<Department>(`/departments/${id}/`);
      return response.data;
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get department workshops
   */
  static async getDepartmentWorkshops(id: number): Promise<any[]> {
    try {
      const response = await apiClient.get(`/departments/${id}/workshops/`);
      return response.data;
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get department statistics
   */
  static async getDepartmentStats(id: number): Promise<any> {
    try {
      const response = await apiClient.get(`/departments/${id}/stats/`);
      return response.data;
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get all departments for dropdown/select options
   */
  static async getDepartmentOptions(): Promise<Array<{ id: number; name: string; code: string }>> {
    try {
      const response = await this.getDepartments({ page_size: 100 });
      return response.results.map(dept => ({
        id: dept.id,
        name: dept.name,
        code: dept.code
      }));
    } catch (error: any) {
      throw new Error(handleApiError(error));
    }
  }
}
